
<template>
  <div id="app">
	  <div v-cloak>
       <RcvV2 />

	  </div>
 
  </div>

</template>


<script>

import RcvV2 from './RcvV2'
import   '../styles/styles.scss'

export default {
  name: "App",
  components: {
  "RcvV2":  RcvV2,
  },
};
</script>




// WEBPACK FOOTER //
// src/App.vue